import { gql } from 'apollo-boost'

const ADVANCED_PROBE_SESSIONS = gql`
  query advancedProbeSessions(
    $page: Int
    $pageSize: Int
    $isTemplate: Boolean
  ) {
    advancedProbeSessions(
      page: $page
      pageSize: $pageSize
      isTemplate: $isTemplate
    ) {
      advancedProbeSessions {
        id
        status
        createdDate
        createdById
        completedDate
        abortedDate
        abortedById
        totalMenuCount
        probedMenuCount
        scrapedMenuCount
      }
      total
    }
  }
`

export default ADVANCED_PROBE_SESSIONS
